import React from "react";

const FeedsSliders = () => {
  return <div className="feeds-sliders"></div>;
};

export default FeedsSliders;
